import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { TableFilterOption } from "@/types";

interface SimpleSelectProps {
  value: string | number | boolean | null | undefined;
  onChange: (value: string | number | boolean | null) => void;
  options: TableFilterOption[];
  placeholder?: string;
  className?: string;
  "aria-label"?: string;
}

export function SimpleSelect({
  value,
  onChange,
  options,
  placeholder,
  className,
  "aria-label": ariaLabel,
}: Readonly<SimpleSelectProps>) {
  const { t } = useTranslation();
  const stringValue = value === null || value === undefined ? "" : String(value);

  return (
    <div className="relative w-64">
      <Select
        value={stringValue}
        onValueChange={val => {
          if (val === "") {
            onChange(null);
          } else {
            // Variant o'z tipida qaytadi: `"true"` satri emas, `true`.
            const option = options.find(o => String(o.value) === val);
            onChange(option ? option.value : val);
          }
        }}
      >
        <SelectTrigger
          aria-label={ariaLabel}
          className={className ?? "w-64 border-none shadow-none focus-visible:ring-[1px]"}
        >
          <SelectValue placeholder={placeholder ?? t("TABLE.SELECT")} />
        </SelectTrigger>
        <SelectContent>
          {options.map(option => (
            <SelectItem key={String(option.value)} value={String(option.value)}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {/* Radix Select bo'sh qiymatni tanlashga yo'l qo'ymaydi — "hammasi"ga
          qaytish uchun alohida tugma kerak. */}
      {value !== null && value !== undefined && (
        <Button
          type="button"
          variant="ghost"
          className="bg-accent absolute top-1 right-1 z-10 size-7"
          aria-label={t("TABLE.CLEAR")}
          onClick={() => onChange(null)}
        >
          <X className="size-4" />
        </Button>
      )}
    </div>
  );
}
